import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { CONTACT } from '../config/products';
import { MessageCircle, ExternalLink, Heart } from 'lucide-react';

export const Footer = () => {
  const { t, isRTL } = useLanguage();

  return (
    <footer className="bg-primary text-primary-foreground py-12 mt-16 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-gradient-radial from-accent to-transparent blur-3xl" />
      </div>

      <div className="max-w-6xl mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo & Company */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="flex flex-col items-center md:items-start gap-3"
          >
            <div className="flex items-center gap-4">
              <div className="font-display text-3xl tracking-wide">
                <span className="font-bold">M</span>
                <span className="text-accent font-bold">'</span>
                <span className="font-bold">art</span>
              </div>
              <span className="text-sm text-primary-foreground/60 border-l border-primary-foreground/20 pl-4">
                {isRTL ? CONTACT.companyHe : CONTACT.company}
              </span>
            </div>
            <p className="text-sm text-primary-foreground/50 text-center md:text-start">
              {t('footerTagline')}
            </p>
          </motion.div>

          {/* Contact */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="flex flex-col items-center md:items-end gap-3"
          >
            <p className="text-sm text-primary-foreground/60">
              {t('questionsContact')}
            </p>
            <motion.a
              href={`https://wa.me/${CONTACT.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 text-primary-foreground hover:text-accent transition-colors"
              whileHover={{ scale: 1.05 }}
            >
              <MessageCircle className="w-6 h-6" />
              <span className="font-semibold text-lg" dir="ltr">{CONTACT.whatsappDisplay}</span>
              <ExternalLink className="w-4 h-4" />
            </motion.a>
          </motion.div>
        </div>

        {/* Bottom */}
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
          className="mt-10 pt-8 border-t border-primary-foreground/10 flex flex-col sm:flex-row items-center justify-between gap-4"
        >
          <p className="text-xs text-primary-foreground/40">
            © {new Date().getFullYear()} Shahal Building Materials Ltd. | M&apos;art Professional Series
          </p>
          <p className="text-xs text-primary-foreground/40 flex items-center gap-1">
            Made with <Heart className="w-3 h-3 text-accent" /> for creators
          </p>
        </motion.div>
      </div>
    </footer>
  );
};
